// extracted by mini-css-extract-plugin
export var dropdownItemContainer = "map-type-selector-module--dropdown-item-container--12d40";
export var label = "map-type-selector-module--label--a1773";
export var mapTypeBtn = "map-type-selector-module--map-type-btn--6ef9a";
export var mapTypeBtnBase = "map-type-selector-module--map-type-btn-base--2ebd2";
export var mapTypeBtnSelected = "map-type-selector-module--map-type-btn-selected--b0732";
export var selectorContainer = "map-type-selector-module--selector-container--61a9b";
export var selectorDropdownBase = "map-type-selector-module--selector-dropdown-base--3a074";
export var selectorLabel = "map-type-selector-module--selector-label--0f7c0";